import React from 'react';
import { useAdditionalData } from 'helpers/categoryHelpers/useAdditionalData';
import { Spinner } from 'components/circleSpinner/Spinner';
import { FormBuilderProps } from 'models/formBuilder';
import { FormBuilder } from 'components/form/FormBuilder';

export default function FormElements<T>(props: FormBuilderProps<T> & { values: T }) {
    const { data, values } = props;

    const { additionalData, pending } = useAdditionalData(data, values as any);

    return pending ? <Spinner /> : <FormBuilder {...props} additionalData={additionalData} />;
}
